import { GetStaticPaths, GetStaticProps } from "next";

import {
  getPagePaths,
  getSanityPageProps,
  PageContent,
} from "@/functions/articlePageFunctions";
import { ArticleLayout } from "@/layouts/ArticleLayout";
import Error404 from "@/pages/404";
import { I18nextLocale } from "@/types/types";
import { getAllTranslationsServerSide } from "@/utils/i18n";

import { ProductCategoryPageProductProps } from "../nettbutikk/[categorySlug]";

type SanityPageProps = {
  content: PageContent;
  products: ProductCategoryPageProductProps[];
  locale: I18nextLocale;
};

export default function SanityPage({ content, products }: SanityPageProps) {
  // Issue a 404 error if content is null
  if (!content) {
    return <Error404 />;
  }

  return <ArticleLayout content={content} products={products}></ArticleLayout>;
}

const ROUTE_SLUG = "inspirasjon";

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = await getPagePaths(ROUTE_SLUG);

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ locale, params }) => {
  const { content, products, siteSettings } = await getSanityPageProps({
    locale,
    slugsArray: params.slug as string[] | undefined,
    routeSlug: ROUTE_SLUG,
  });

  return {
    props: {
      ...(await getAllTranslationsServerSide(locale as I18nextLocale)),
      content,
      locale,
      products,
      siteSettings,
    },
    revalidate: 10,
  };
};
